ui-cms-search-autosuggest {
  display: block;

  .ui-autosuggest::part(dropdown) {
    max-height: calc(100vh - 160px);
  }
}
